// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-card-info, .job-card-skill {
  width: 100%;
  padding: 24px;
}

.job-card-info {
  height: 229px !important;
}

.job-card-description-col {
  height: 82px !important;
  margin-top: 16px;
}

.job-horizontal-line {
  border: 1px solid #EEEEEE !important;
  opacity: 1;
  margin: 0 !important;
  padding: 0 !important
}

.job-card-mca {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.job-parent-card {
  background: #FFFFFF 0 0 no-repeat padding-box !important;
  box-shadow: 0 2px 4px #00000014;
  border-radius: 4px;
  opacity: 1;
  height: 410px;
  width: 320px;
  border-bottom: 0 !important;
}

.job-parent-card .ant-card-body {
  padding: 0 !important;
}

.job-card-title {
  text-align: left;
  margin-bottom: 0 !important;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-card-seniority {
  text-align: left;
  margin-bottom: 0 !important;
  color: #444444 !important;
  opacity: 1;
  font: normal normal normal 14px/22px;
}

.job-card-description {
  text-align: left;
  margin-bottom: 0 !important;
  letter-spacing: 0;
  color: #888888 !important;
  opacity: 1;
  font: normal normal normal 14px/21px;
}

.job-card-button {
  padding: 0 !important;
  text-align: left !important;
  height: 19px !important;
  font-size: 14px !important;
  font-weight: 500;
  line-height: 19px !important;
  letter-spacing: 0.56px !important;
  color: #56A8F7 !important;
  opacity: 1;
}

 .job-card-button:hover, .job-mcq-start:hover {
  background-color: #FFFFFF !important;
  color: #56A8F7 !important;
}

.job-skill-icon {
  width: 24px;
  height: 24px
}

.job-mcq-start {
  padding: 0 !important;
  margin-left: -10px !important;
  text-align: right !important;
  font-size: 12px !important;
  height: 16px !important;
  font-weight: 500;
  line-height: 16px !important;
  letter-spacing: 0.48px !important;
  color: #56A8F7 !important;
  opacity: 1;
}

.job-skill-title {
  text-align: left !important;
  font-size: 14px !important;
  line-height: 19px !important;
  font-weight: 500;
  letter-spacing: 0 !important;
  color: #212121 !important;
  opacity: 1;
}

.job-skill-name {
  text-align: left;
  font-size: 12px !important;
  line-height: 16px;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-card-mca-title {
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0;
  color: #212121 !important;
  opacity: 1;
}

.job-card-mca-description {
  font-size: 12px !important;
  font-weight: 500;
  line-height: 16px !important;
  letter-spacing: 0;
  color: #888888 !important;
  opacity: 1;
}

.gray-round-icon {
  background: #EEEEEE 0% 0% no-repeat padding-box;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.no-test-available {
  color: #AAAAAA;
  font: normal normal normal 12px/16px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/JobCard/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,UAAU;AACZ;;CAEC;EACC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC","sourcesContent":[".job-card-info, .job-card-skill {\n  width: 100%;\n  padding: 24px;\n}\n\n.job-card-info {\n  height: 229px !important;\n}\n\n.job-card-description-col {\n  height: 82px !important;\n  margin-top: 16px;\n}\n\n.job-horizontal-line {\n  border: 1px solid #EEEEEE !important;\n  opacity: 1;\n  margin: 0 !important;\n  padding: 0 !important\n}\n\n.job-card-mca {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.job-parent-card {\n  background: #FFFFFF 0 0 no-repeat padding-box !important;\n  box-shadow: 0 2px 4px #00000014;\n  border-radius: 4px;\n  opacity: 1;\n  height: 410px;\n  width: 320px;\n  border-bottom: 0 !important;\n}\n\n.job-parent-card .ant-card-body {\n  padding: 0 !important;\n}\n\n.job-card-title {\n  text-align: left;\n  margin-bottom: 0 !important;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-card-seniority {\n  text-align: left;\n  margin-bottom: 0 !important;\n  color: #444444 !important;\n  opacity: 1;\n  font: normal normal normal 14px/22px;\n}\n\n.job-card-description {\n  text-align: left;\n  margin-bottom: 0 !important;\n  letter-spacing: 0;\n  color: #888888 !important;\n  opacity: 1;\n  font: normal normal normal 14px/21px;\n}\n\n.job-card-button {\n  padding: 0 !important;\n  text-align: left !important;\n  height: 19px !important;\n  font-size: 14px !important;\n  font-weight: 500;\n  line-height: 19px !important;\n  letter-spacing: 0.56px !important;\n  color: #56A8F7 !important;\n  opacity: 1;\n}\n\n .job-card-button:hover, .job-mcq-start:hover {\n  background-color: #FFFFFF !important;\n  color: #56A8F7 !important;\n}\n\n.job-skill-icon {\n  width: 24px;\n  height: 24px\n}\n\n.job-mcq-start {\n  padding: 0 !important;\n  margin-left: -10px !important;\n  text-align: right !important;\n  font-size: 12px !important;\n  height: 16px !important;\n  font-weight: 500;\n  line-height: 16px !important;\n  letter-spacing: 0.48px !important;\n  color: #56A8F7 !important;\n  opacity: 1;\n}\n\n.job-skill-title {\n  text-align: left !important;\n  font-size: 14px !important;\n  line-height: 19px !important;\n  font-weight: 500;\n  letter-spacing: 0 !important;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-skill-name {\n  text-align: left;\n  font-size: 12px !important;\n  line-height: 16px;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-card-mca-title {\n  font-size: 14px !important;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #212121 !important;\n  opacity: 1;\n}\n\n.job-card-mca-description {\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 16px !important;\n  letter-spacing: 0;\n  color: #888888 !important;\n  opacity: 1;\n}\n\n.gray-round-icon {\n  background: #EEEEEE 0% 0% no-repeat padding-box;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.no-test-available {\n  color: #AAAAAA;\n  font: normal normal normal 12px/16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
